module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Content_Report

(function (fox, $) {
	'use strict';

var subjectItem = {
	photosets: "photoset",
	gallery: "photoset",
	scene: "video",
	product: "store",
	liveshow: "liveshow",
	post: "blog"
}

	fox.registerWidget('Content_Report', {
		configure: function () {
			this.registerOptions('', {
				template: 'a.content-report-link{Report content}',
				'embed.container': '.content-report',
				autoRender: true,
				additionalPopupClass: 'black-diamond-skin',
				widgets: {
					api: {
						widget: 'Api',
						method: 'report.send',
						handleWom: {
							apiSuccessHandler: {
								widget: '@this',
								event: 'success',
								callback: '@parent:apiSuccessHandler'
							},
							apiFailureHandler: {
								widget: '@this',
								event: ['error', 'failure'],
								callback: '@parent:apiFailureHandler'
							}
						}
					},
					reportPopup:{
						widget: 'Dialog',
						template: '',
						useUiPosition: true,
						dialog: {
							autoOpen: false,
							title: 'Report Content',
							closeText: '',
							width: '535px',
							buttons: [
								{text: 'Cancel', class: 'cancel-report'},
								{text: 'Submit', class: 'submit-report'}
							]
						},
						widgets: {
							reportForm: {
								widget: 'Widget',
								template: 'report_content_form',
								templateOptions: {prefix: this.getOption('prefixPopup')},
								autoRender: true,
								'widgets.form': {
									widget: 'Form',
									loadValuesOnRun: false,
									formElements: {
										type: {element: '[name="type"]'},
										comment: {element: '[name="comment"]'}
									}
								}
							}
						},
						'handleWom.showButtons': {
							widget: '@this',
							event: 'show',
							callback: '@parent:_showHideButtons'
						}
					}
				},
				handleDom: {
					clickOnReportLink: {
						event: 'click',
						target: '.content-report-link',
						callback: 'showPopup'
					},
					submitReportForm: {
						targetWidget: '#reportPopup',
						event: 'click',
						target: '.submit-report',
						callback: 'submitForm'
					},
					cancelReportForm: {
						targetWidget: '#reportPopup',
						event: 'click',
						target: '.cancel-report',
						callback: 'cancelReportForm'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('#reportPopup', {
				dialog: {
					dialogClass: 'dlg-amc dark-overlay ' + this.getOption('additionalPopupClass')
				}
			});
			
			if (!fox.site.member) {
				this.registerOptions('~#form', {
					formElements: {
						email: {element: '[name="email"]'},
						captcha: {element: '[name="captcha"]'}
					}
				});

				this.registerOptions('~#reportForm', {
					'widgets.captcha': {
						widget: 'Captcha',
						'embed.container': '#captcha'
					},
					'handleDom.reloadCaptcha': {
						event: 'click',
						target: '.reload-captcha',
						callback: '#captcha:loadCaptcha'
					},
				});

				if (this.getOption('captchaAlias')) {
					this.registerOptions('~#reportForm', {
						'widgets.captcha.captchaAlias': this.getOption('captchaAlias')
					});
				}
			}

			this.callParent('init', arguments);
		},

		running: function () {
			this._form = this.rwom1('~#form');
			this.rwom1('~#reportForm').setTemplateOptions({prefix:this.getOption('prefixPopup')}).render();
			this.callParent('running', arguments);
		},

		cancelReportForm: function () {
			this._form.resetForm();
			this.rwom1('#reportPopup').hide();
		},

		showPopup: function (el) {
			var popup = this.rwom1('#reportPopup');
			if(el.getAttribute('data-subject')){
				var conversId = fox.wom.selectFirst('~.ConversationViewer').dl._collection[0].conversationId;
				popup.wom1('#reportForm').setTemplateOptions({reportId:conversId, subj:'message'}).render();
			}
			popup.show();
		},

		submitForm: function (el) {
			var formData = this._form.collectData(),
			subject,
			contentId;
			if(el.getAttribute('data-id')){
				subject='messages';
				contentId = el.getAttribute('data-id');
			}else{
				subject = subjectItem[fox.Navigator.get(0)];
				contentId = fox.Navigator.get(1);
			}
		
			formData.subject = subject;
			formData.contentId = contentId;
			if (!fox.site.member) {
				formData.captchaId =  this.rwom1('~.Captcha#captcha').captchaId;
			}

			this._submitForm(formData);
		},

		_submitForm: function (formData) {
			this.rwom1('#api').send(formData, false);
		},

		apiSuccessHandler: function () {
			this._showHideButtons(true);
		},

		apiFailureHandler: function (data) {
			$('#error-container')
				.text(data.answer.reason)
				.fadeIn(400, function () {
					setTimeout(fox.bind(function () {
						$(this).fadeOut();
					}, this), 5000);
				});
		},

		setContentId: function (data) {
			this._contentId = data;
		},

		_showHideButtons: function (action) {
			this.hookWrapper('showHideButtons', action);
		},

		showHideButtons: function (action) {
			var buttons = $(this.rwom1('#reportPopup').element[0])
				.find('.ui-dialog-buttonpane, .popup-footer, .popup-footer-wrapper');

			$(this.rwom1('~#reportForm').element[0])
				.find('form')[action === true ? 'hide' : 'show']()
				.next()[action === true ? 'show' : 'hide']();
			
			var res = action === true ?
				buttons.hide() : 
				buttons.show();
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/contentreport.js
// module id = 827
// module chunks = 4